import { render, staticRenderFns } from "./LargeFiles.vue?vue&type=template&id=3a99a7f4&scoped=true&"
import script from "./LargeFiles.vue?vue&type=script&lang=js&"
export * from "./LargeFiles.vue?vue&type=script&lang=js&"
import style0 from "./LargeFiles.vue?vue&type=style&index=0&id=3a99a7f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a99a7f4",
  null
  
)

export default component.exports